import createLucideIcon from '../createLucideIcon';

const Moon = createLucideIcon('MoonIcon', [
  ['path', { d: 'M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z', key: 'a7tn18' }],
]);

export default Moon;
